import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Switch
} from "@mui/material";
import { useState } from "react";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { TFiltroListarOcs } from "..";

export default function DialogListarOCFilter({
  open,
  filtrosAtuais,
  onClose,
  onConfirm
}: DialogListarOCFilterProps) {
  const [internalFilters, setInternalFilters] = useState<TFiltroListarOcs>(filtrosAtuais);

  const handleConfirm = () => {
    const novosFiltros: TFiltroListarOcs = {
      ...filtrosAtuais,
      status: internalFilters.status ? internalFilters.status : undefined,
      somenteValorOperacao: internalFilters.somenteValorOperacao
    };

    onConfirm(novosFiltros);
    onClose();
  };

  const clearFiltros = () => {
    setInternalFilters({});
    onConfirm({});
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Filtros
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={{ xs: 12 }}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="switch-operacao" sx={{ mb: 1 }}>
                Somente valor da operação
              </InputLabel>
              <Switch
                id="switch-operacao"
                checked={!!internalFilters.somenteValorOperacao}
                onChange={(_, checked) => {
                  setInternalFilters({
                    ...internalFilters,
                    somenteValorOperacao: checked
                  });
                }}
                color="primary"
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControl fullWidth>
              <InputLabel id="status-oc-select-label">Status</InputLabel>
              <Select
                labelId="status-oc-select-label"
                id="status-oc-select"
                value={internalFilters.status ? internalFilters.status[0] : ''}
                label="Status"
                onChange={(event) => {
                  setInternalFilters({
                    ...internalFilters,
                    status: event.target.value ? [event.target.value] : undefined
                  });
                }}
              >
                <MenuItem value=""><em>Selecione um status</em></MenuItem>
                <MenuItem value="Em aberto">Em aberto</MenuItem>
                <MenuItem value="Finalizado">Finalizado</MenuItem>
                <MenuItem value="Cancelada">Cancelada</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={clearFiltros}>Limpar</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogListarOCFilterProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (filters: TFiltroListarOcs) => void;
  filtrosAtuais: TFiltroListarOcs;
}